import React, { Component } from "react";
import { Fade, Slide } from "react-reveal";

class Info extends Component {
    render() {
        if (!this.props.data) return null;

        const whatsapp = this.props.data.whatsapp;
        const email = "mailto:" + this.props.data.email;
        const instagram = this.props.data.instagram;
        const facebook = this.props.data.facebook;
        const telegram = this.props.data.telegram;

        const logo_whatsapp = "images/" + this.props.data.loghi.whatsapp;
        const logo_email = "images/" + this.props.data.loghi.email;
        const logo_telegram = "images/" + this.props.data.loghi.telegram;
        const logo_instagram = "images/" + this.props.data.loghi.instagram;
        const logo_facebook = "images/" + this.props.data.loghi.facebook;

        //<section id="contact" style={{background:"url(images/info_background.png)" }}>

        return (


            <section id="contact" style={{ backgroundColor: "#1d1a1c"}}>
                <div className="row">
                    <Slide right duration={1000}>
                        {/*    <aside className="four columns footer-widgets" style={{ background: "#ffffff98" }}>
                            <div className="widget widget_contact">
                                <h3>Info e Contatti</h3>
                                <p className="address" style={{ color: "#dbdddd" }} >
                                    <div className="row" style={{ marginTop: "10px" }}>
                                        <div className="eight columns">
                                            <a className="social-links" target="blank" style={{ marginRight: "15px" }} href={whatsapp}>
                                                <img src={logo_whatsapp} style={{ width: "20%" }} />
                                            </a>
                                            <a target="blank" style={{ marginRight: "15px" }} href={email}>
                                                <img src={logo_email} style={{ width: "20%" }} />
                                            </a>
                                            <a target="blank" style={{ marginRight: "15px" }} href={telegram}>
                                                <img src={logo_telegram} style={{ width: "20%" }} />
                                            </a>
                                        </div>
                                    </div>
                                </p>
                            </div>
                            <div className="widget widget_contact">
                                <h3>Social</h3>
                                <p className="address" style={{ color: "#dbdddd" }} >
                                    <div className="row" style={{ marginTop: "10px" }}>
                                        <div className="eight columns">
                                            <a className="social-links" target="blank" style={{ marginRight: "15px" }} href={instagram}>
                                                <img src={logo_instagram} style={{ width: "20%" }} />
                                            </a>
                                            <a target="blank" style={{ marginRight: "15px" }} href={facebook}>
                                                <img src={logo_facebook} style={{ width: "20%" }} />
                                            </a>

                                        </div>
                                    </div>
                                </p>
                            </div>

        </aside> */}
                        <h1 className="text-center">
                            <span style={{ color: "#fff", textShadow: "2px 2px 2px #000", fontFamily: 'font-italic-dttm' }}>CONTATTI</span>
                        </h1>
                    
                        <div className="twelve columns footer-widgets text-center" style={{ paddingBottom: "30px" }}>
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2948.6551105426156!2d11.607349215607378!3d42.34987597918764!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1328ec0225a14735%3A0x91cf6c577cb152c3!2sTeatro%20Lea%20Padovani!5e0!3m2!1sit!2sit!4v1648296144342!5m2!1sit!2sit" 
                                className="maps" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                        <Fade bottom>
                            <div>
                                <ul className="social-links text-center" >
                                    <a className="social-links" target="blank" style={{ marginRight: "15px" }} href={whatsapp}>
                                        <img alt="whatsapp" src={logo_whatsapp} style={{ width: "45px" }} />
                                    </a>
                                    <a target="blank" style={{ marginRight: "15px" }} href={telegram}>
                                        <img alt="telegram" src={logo_telegram} style={{ width: "45px" }} />
                                    </a>
                                    <a target="blank" style={{ marginRight: "15px" }} href={email}>
                                        <img alt="email" src={logo_email} style={{ width: "45px" }} />
                                    </a>
                                    <a className="social-links" target="blank" style={{ marginRight: "15px" }} href={instagram}>
                                        <img alt="instagram" src={logo_instagram} style={{ width: "45px" }} />
                                    </a>
                                    <a target="blank" style={{ marginRight: "15px" }} href={facebook}>
                                        <img alt="facebook" src={logo_facebook} style={{ width: "45px" }} />
                                    </a>
                                </ul>


                            </div>
                        </Fade>
                    </Slide>
                </div>
            </section>
        );
    }
}

export default Info;
